/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { typedDependencies } from './dependenciesTyped.generated.js';
import { createCube } from '../../factoriesAny.js';
export var cubeDependencies = {
  typedDependencies,
  createCube
};